// extracted by mini-css-extract-plugin
module.exports = {"legend_fixed_container":"LegendFixed_legend_fixed_container__1KOKX","close_btn":"LegendFixed_close_btn__1qgBq","close_legend_container":"LegendFixed_close_legend_container__3dnnX"};